module.exports = __webpack_public_path__ + "img/ecommerce-background.c4d9528a.svg";